
import request from '@/http/http'
const PREFIX = 'api/saas';
export function getEditions(query) {
    return request({
        url: PREFIX + '/editions',
        params:query
    })
}
export function getEditionInfo(id) {
    return request({
        url: `${PREFIX}/editions/${id}`,
    })
}
export function deleteEdition(id) {
    return request({
        url: `${PREFIX}/editions/${id}`,
        method: 'delete',
    })
}
export function creatEdition(data) {
    return request({
        url: PREFIX + "/editions",
        method: 'post',
        data
    })
}
export function updateEdition(id,data) {
    return request({
        url: `${PREFIX}/editions/${id}`,
        method: 'put',
        data
    })
}